import { Select } from "antd";
import { useEffect, useState } from "react";
import { SizeType } from "antd/es/config-provider/SizeContext";
import { useSelector } from "react-redux";
import store from "../../../../controllers/store";
import { find } from "../../../../controllers/store/actions/searchers/get-searchers-actions";
import { PageSetting } from "../../..";

interface Props {
  onChange: (value: string) => void;
  size?: SizeType;
  onClear: () => void;
  mode?: any;
  defaultValue?: any;
  style?: any;
}
const dispatch = store.dispatch;
const SelectSearchers = (props: Props) => {
  const Searcherstate = useSelector((state: any) => state.searchers);
  const userState = useSelector((state: any) => state.user);

  useEffect(() => {
    if (userState.user.me.role.name === "Admin") {
      dispatch(
        find(PageSetting.page, -1, {
          filter: {},
        })
      );
    } else {
      dispatch(
        find(PageSetting.page, -1, {
          filter: {},
        })
      );
    }
  }, []);

  return (
    <div style={{ width: "100%" }}>
      <Select
        {...props}
        allowClear
        loading={Searcherstate.isLoading}
        size={props.size}
        labelInValue={props.mode === "multiple" ? true : false}
        defaultValue={props.defaultValue ? props.defaultValue : []}
        style={props.style}
        onChange={(value: any) => {
          props.onChange(value);
        }}
        options={
          Searcherstate?.list?.map((e: any) => ({
            label: e.nombre,
            value: e.id,
          })) || []
        }
      />
    </div>
  );
};

export default SelectSearchers;
